<template>
  <div>
    <popup-hint hint="salesReps">
      <template v-slot:breadcrumbs>
        <breadcrumbs home="Sales representatives" :back="back"/>
      </template>
      <template v-slot:top>
        Sales representatives can be assigned to a sale so that commissions can be calculated for representatives.
      </template>
    </popup-hint>

    <purtrak-table name="salesReps" objectType="sales representatives" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="salesReps2"
                   fields="id,name,email,userId,active,commissionPercent,restricted"
                   :listFilters="listFilters"
                   @dblclick="salesRep => $router.push({name:'SalesRepsEdit',params:{salesRepId:salesRep.id}})"
                   :item-class="salesRep => (salesRep.active ? '' : 'grey--text')"
                   title="Sales representatives"
                   :print-info="{subTitle:[filters.status!='1'?(filters.status=='0'?'Inactive':'All'):'']}"
                   download-endpoint="salesRepsExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.status='1';filters.search=''">
          <v-list-item>
            <filter-search label="Name" v-model="filters.search"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{divider:true},{value:'1',text:'Active'},{value:'0',text:'Inactive'}]" v-model="filters.status"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search=''">Name: {{filters.search}}</v-chip>
          <v-chip v-show="filters.status!='1'" close small class="ml-1" @click:close="filters.status='1'">{{filters.status=='0'?'Inactive':'All'}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'SalesRepsEditNew'}"><v-list-item-title>Create sales representative</v-list-item-title></v-list-item>
          <v-divider/>
        </template>
        <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Sales representatives',to:{name:'SalesReps'}}]},query:{to:'reports/sales/ReportsSalesRepsSummary'}}"><v-list-item-title>Sales commissions summary</v-list-item-title></v-list-item>
        <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Sales representatives',to:{name:'SalesReps'}}]},query:{to:'reports/sales/ReportsSalesRepsDetails'}}"><v-list-item-title>Sales commissions details</v-list-item-title></v-list-item>
      </template>

      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'SalesRepsEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.user="{item,printing}">
        <template v-if="printing">{{!!item.userId?'Y':''}}</template>
        <v-icon v-else-if="!!item.userId">mdi-check</v-icon>
      </template>
      <template v-slot:item.restricted="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon color="green" v-else-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:item.commissionPercent="{value}">
        <template v-if="!!value">
          {{value | number(2)}}%
        </template>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="200" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small icon v-on="on"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <template>
              <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Sales representatives',to:{name:'SalesReps'}}]},query:{to:'reports/sales/ReportsSalesRepsDetails',salesRepId:item.id}}"><v-list-item-title>Sales commissions details</v-list-item-title></v-list-item>
              <v-divider/>
              <v-list-item :to="{name:'SalesRepsEdit',params:{salesRepId:item.id}}"><v-list-item-title>Edit sales representative</v-list-item-title></v-list-item>
              <v-list-item @click="salesRep=item;showDelete=true"><v-list-item-title>Delete sales representative</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this sales representative" @delete="performDelete"/>
  </div>
</template>

<script>

export default {
  name: 'SalesSalesReps',
  props: {
    back: {type:Array, required:false}
  },
  data() {
    return {
      filters: {
        status: '1',
        search: ''
      },
      salesRep: {},
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'email', visible:true},
                       { value: 'user', visible:true},
                       { value: 'restricted', visible:false},
                       { value: 'commissionPercent', visible:true}],
      headers: [{ text: 'NAME', value: 'name', width:'25%',sortable:true},
                { text: 'EMAIL', value: 'email' ,width:'25%',sortable:true},
                { text: 'USER', value: 'user' ,width:'10%',sortable:false,align:'center'},
                { text: 'RESTRICTED', value: 'restricted' ,width:'10%',sortable:false,align:'center'},
                { text: 'COMMISSION', value: 'commissionPercent' ,width:'20%',align:'right',sortable:true}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('config.write');
    },
    listFilters() {
      const filters = [];
      if (this.filters.status == '1' || this.filters.status == '0')
        filters.push({field:'active', comparator:'eq', value:this.filters.status == '1' ? 'true' : 'false'});
      if (this.filters.search)
        filters.push({field:'name', comparator:'contains', value:this.filters.search});

      return filters;
    }
  },
  methods: {
    async performDelete() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SalesReps($id: ID!) {
                                             objectDelete(id:$id)
                                            }`,
                                          {id:this.salesRep.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted sales reprentative ${this.salesRep.name}`});
      }
    }
  }
}
</script>